import React from "react";
import Grid from "@material-ui/core/Grid";
import SilverItem from "../../../../assets/images/silver_item.png";
import GoldItem from "../../../../assets/images/gold_item.png";
import Light from "../../../../assets/images/img_raund_light.png";
import Lock from "../../../../assets/images/lock.png";

import '../../../../App.scss';

class Polygon extends React.Component{
    constructor(props){
        super(props)
        this.state={
            prp:null,
            animation:null,
        }
    }
    render() {
        const {
            icon,
            text,
            textColor,
            locked,
            polygon,
            hasGlowBackground}=this.props.data

        return(
            <Grid item container alignItems={"center"} justify={"center"} sm={12} style={{
                // backgroundImage: `url(${locked  ? GoldItem : SilverItem})`,
                backgroundImage: `url(${polygon})`,
                backgroundSize:'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition:'center',
                width: '100%',
            }}
            className='polygon'
                  direction={"column"}
            >
                <Grid container justify={"center"} alignItems={"center"}>
                    <img src={icon} className='polygon-image' alt=""/>
                </Grid>
                <Grid>
                    <p style={{color:textColor}}>
                        {text}
                    </p>
                </Grid>
                {hasGlowBackground
                    &&
                <img src={Light} className='polygon-light' alt=""/>
                }
                {locked
                    &&
                <img src={Lock} className='polygon-lock' alt=""/>
                }
            </Grid>
        )
    }
}
export default Polygon